import { render, staticRenderFns } from "./rest_takeout.vue?vue&type=template&id=98fe9c22&"
import script from "./rest_takeout.vue?vue&type=script&lang=js&"
export * from "./rest_takeout.vue?vue&type=script&lang=js&"
import style0 from "./rest_takeout.vue?vue&type=style&index=0&id=98fe9c22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports